import vcWarning, { resetWarned, noteOnce } from '../vc-util/warning';
export { resetWarned };
export function noop() { }
let warningConfig = {
    strict: true,
};
export function setWarningConfig(config = {}) {
    warningConfig = Object.assign(Object.assign({}, warningConfig), config);
}
export function getWarningConfig() {
    return warningConfig;
}
// eslint-disable-next-line import/no-mutable-exports
let warning = noop;
if (process.env.NODE_ENV !== 'production') {
    warning = (valid, component, message) => {
        const text = `[ant-design-vue: ${component}] ${message}`;
        if (warningConfig.strict === false) {
            noteOnce(valid, text);
        }
        else {
            vcWarning(valid, text);
        }
        // StrictMode will inject console which will not throw warning in React 17.
        if (process.env.NODE_ENV === 'test') {
            resetWarned();
        }
    };
}
export default warning;
